import { ActionContext, ActionTree } from "vuex";
import { StatusCodes } from "http-status-codes";
import DuplicateBookingsService from "@/modules/DuplicateBookings/services/duplicateBookings.service";
import { DuplicateBookingsQueryPayload } from "@/modules/DuplicateBookings/constants";
import { IDuplicateBookingsState } from "@/modules/DuplicateBookings/vuex/state";
import { StoreState } from "@/store/type";
import notificationService from "@/core/services/notification.service";
import { NOTIFICATION_TYPES } from "@/core/enums/NOTIFICATION_TYPES";

const duplicateBookingsService = new DuplicateBookingsService();

const actions: ActionTree<IDuplicateBookingsState, StoreState> = {
  async fetchDuplicateBookings(
    context: ActionContext<IDuplicateBookingsState, StoreState>,
    payload: DuplicateBookingsQueryPayload,
  ) {
    try {
      context.commit("setDuplicateBookingsLoading", true);
      context.commit("setDuplicateBookingsError", null);

      const response =
        await duplicateBookingsService.fetchDuplicateBookings(payload);
      const { success, status, data } = response.data;

      if (success && status === StatusCodes.OK) {
        d;
        context.commit("setDuplicateBookingsData", data);

        return response;
      }

      throw response;
    } catch (error) {
      const errorMessage = (error as Error).message;
      context.commit("setDuplicateBookingsError", errorMessage);
      notificationService.type = NOTIFICATION_TYPES.ERROR;
      notificationService.description = errorMessage;
      notificationService.triggerNotification();
      return error;
    } finally {
      context.commit("setDuplicateBookingsLoading", false);
    }
  },
  resetDuplicateBookings(
    context: ActionContext<IDuplicateBookingsState, StoreState>,
  ) {
    context.commit("resetDuplicateBookingsState");
  },
};

export default actions;
